// Push «Отдых окончен» и «Время вышло» (цель подхода на время): свёрнутое PWA телефон
// замораживает, поэтому момент сообщается серверу (PUT/DELETE /api/rest-alarm), и в нужную
// секунду push приходит в шторку и на часы. Будильник один: отдых и подход не идут вместе.
// Без сети или без входа — просто без напоминания: на экране таймер работает и так.
// Новый отдых или «Хватит» убирают из шторки уже показанное «Отдых окончен».

import { api } from '@/api/client'
import { restTimer } from '@/lib/restTimer'

/** Хвост тега уведомления: SW ставит `${user_id}:${kind}`. */
const TAG_SUFFIX = ':rest_over'

async function closeShown(): Promise<void> {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return
  const registration = await navigator.serviceWorker.getRegistration()
  if (!registration || typeof registration.getNotifications !== 'function') return
  for (const notification of await registration.getNotifications()) {
    if (notification.tag.endsWith(TAG_SUFFIX)) notification.close()
  }
}

// Запросы по очереди: «−15» и «Хватит» подряд не должны прийти на сервер в обратном порядке.
let chain: Promise<unknown> = Promise.resolve()

/** Поставить будильник на `endsAt` (null — снять); `exercise` — это цель подхода, а не отдых. */
export function syncRestAlarm(endsAt: number | null, exercise?: string): Promise<unknown> {
  void closeShown().catch(() => undefined)
  chain = chain
    .then(() =>
      endsAt === null
        ? api.delete('/rest-alarm')
        : api.put('/rest-alarm', { ends_at: new Date(endsAt).toISOString(), exercise: exercise ?? null }),
    )
    .catch(() => undefined)
  return chain
}

restTimer.onSchedule((endsAt) => void syncRestAlarm(endsAt))
